import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Section = styled(Stack)`
  padding: 0 20px;
`;

export const OvertimeTable = styled('table')`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 8px;
  overflow: hidden;

  .col-date {
    text-align: left;
    width: 26%;
  }
  .col-expiry {
    width: 26%;
    text-align: left;
  }
  .col-type {
    width: 15%;
    text-align: left;
  }
  .col-hours {
    width: 21%;
    text-align: right;
  }
  .col-kebab {
    width: 12%;
    text-align: center;
    padding: 8px;
    /* 셀 높이를 콘텐츠(8+8+20=36px)에 맞추기 위해 인라인 baseline 여백 제거 */
    line-height: 0;
  }

  thead {
    background: var(--dk-bg-subtle, #f9fafb);
    color: var(--dk-text, #000);

    tr th {
      padding: 8px;
      font-weight: inherit;
      border-bottom: 1px solid var(--dk-line, #e7e9ec);
    }

    tr th:last-of-type {
      width: 12%;
      padding: 8px;
    }
  }

  tbody {
    tr {
      td {
        padding: 8px;
        color: var(--dk-text, #000);
        font-weight: inherit;
        border-bottom: 1px solid var(--dk-line, #e7e9ec);

        &.col-date {
          color: var(--dk-text, #000);
          &.link {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        &.col-expiry {
          color: var(--dk-text, #000);
        }

        /* 적립(+) 은 포인트 컬러, 사용(-) 은 기본 컬러 */
        &.col-type.plus,
        &.col-hours.plus {
          color: var(--dk-accent, #0066cc);
        }

        &.col-hours.minus {
          color: var(--dk-text, #000);
        }

        &.col-kebab {
          padding: 8px;
          text-align: center;
        }

        &.col-more {
          padding: 0;
        }
      }
    }

    tr:last-of-type td {
      border-bottom: none;
    }
  }
`;
